import React, { useEffect, useMemo, useRef, useState } from 'react';
import './CustomizeTable.scss';
import { Field, Form, Formik } from "formik";
import { Button, Col, Input, InputGroup, InputGroupText, Row } from 'reactstrap';
import FeatherIcon from "feather-icons-react";
import { Checkbox } from 'primereact/checkbox';
import { customizeTableColumns, customizeTableProbs } from 'src/models/components/CustomizeTableColumns';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

const prepareInitialValues = (columns:any) => {
  const initialValues:any = { searchValue: "" };
  columns.forEach((column:any) => {
    initialValues[column.field] = column.value;
  });
  return initialValues;
};

function JobCustomizeTable({ onCancelHandler, onCustomizeColumnSubmitHandler, columns }: customizeTableProbs) {
  const [searchedValues, setSearchedValues] = useState(columns);
  const [orderedColumns, setOrderedColumns] = useState(columns);

  const initialValues = prepareInitialValues(columns);

const handleSubmit = (formValue: any) => {
  // Build ordered and visibility-aware result
  const result = orderedColumns.map((col) => ({
    ...col,
    value: formValue[col.field] // get visibility value from Formik
  }));

  onCustomizeColumnSubmitHandler(result); // Pass back ordered + visibility
};
const searchColumnsHandler = (event:any,setFieldValue:any) => {
  const searchValue = event.target?.value?.toLowerCase();
  const filteredValues = orderedColumns.filter((column) => {
    return column?.header?.toLowerCase().includes(searchValue);
  });
  setSearchedValues(filteredValues);
  setFieldValue('searchValue',event.target?.value)
};

useEffect(() => {
  setSearchedValues(orderedColumns); // initialize with ordered list
}, [orderedColumns]);

  console.log(searchedValues,"searchedValues")
  const onDragEnd = (result:any) => {
    if (!result.destination) return;

    const newOrder = Array.from(orderedColumns);
    const [movedItem] = newOrder.splice(result.source.index, 1);
    newOrder.splice(result.destination.index, 0, movedItem);

    setOrderedColumns(newOrder);
    setSearchedValues(newOrder);
  };

  const totalColumns = useMemo(()=>columns?.length, [columns]) 
  const visibleColumns =useMemo(()=>columns.filter((column) => column.value).length,[columns]) 

  const containerRef:any = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event:any) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onCancelHandler();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div id="customize-table" ref={containerRef}>
      <h4>Customize table</h4>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, handleChange,setFieldValue }) => (
          <Form>
            <Row>
              <Col xs={12}>
                <InputGroup>
                  <InputGroupText>
                    <FeatherIcon icon="search" className="margin-right-10" />
                  </InputGroupText>
                  <Input type="text" name="searchValue" value={values.searchValue} onChange={(e)=>{searchColumnsHandler(e,setFieldValue)}} placeholder='Search' />
                </InputGroup>
                <h6>Field visible in the table <span className='span-total-column-display'>{Object.keys(values).filter((key) => key !== "searchValue" && values[key]).length}/{totalColumns}</span></h6>
              </Col>

              <Col xs={12} className='field-list-container'>
                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId="columns-list">
                    {(provided:any) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {searchedValues.map((category, index) => (
                          <Draggable key={category.field} draggableId={category.field} index={index}>
                            {(provided:any) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                className="flex align-items-center draggable-item"
                              >
                                <Checkbox
                                  inputId={category.field}
                                  disabled={category.isDisable}
                                  name={category.field}
                                  checked={values[category.field]}
                                  onChange={handleChange}
                                />
                                <label htmlFor={category.field} className="ml-2">
                                  {category.header}
                                </label>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>

                {searchedValues.length === 0 && (
                  <div className='no-match-found'>No match found.</div>
                )}
              </Col>

              <Col xs={12} className='btn-container d-flex justify-content-end'>
                <Button className="secondary-btn me-2" color="primary" type="button" onClick={onCancelHandler}>Cancel</Button>
                <Button className="btn btn-primary" color="primary" type="submit">Apply</Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default JobCustomizeTable;
